import { useState } from 'react';

function App() {
  const [first, setFirst] = useState('');
  const [second, setSecond] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleSum = () => {
    setError('');
    setResult(null);

    const a = parseFloat(first);
    const b = parseFloat(second);

    if (first.trim() === '' || second.trim() === '' || Number.isNaN(a) || Number.isNaN(b)) {
      setError('Please enter valid numbers in both fields.');
      return;
    }

    setResult(a + b);
  };

  return (
    <main style={styles.main}>
      <div style={styles.card}>
        <h1 style={styles.title}>Sum Calculator</h1>
        <label htmlFor="first" style={styles.label}>
          First number
        </label>
        <input
          id="first"
          type="text"
          inputMode="decimal"
          value={first}
          onChange={(e) => setFirst(e.target.value)}
          style={styles.input}
          placeholder="e.g. 12"
        />
        <label htmlFor="second" style={styles.label}>
          Second number
        </label>
        <input
          id="second"
          type="text"
          inputMode="decimal"
          value={second}
          onChange={(e) => setSecond(e.target.value)}
          style={styles.input}
          placeholder="e.g. 34"
        />
        <button type="button" onClick={handleSum} style={styles.button}>
          Sum
        </button>
        {error && <p style={styles.error}>{error}</p>}
        {result !== null && !error && (
          <p style={styles.result}>
            Result: <strong>{result}</strong>
          </p>
        )}
      </div>
    </main>
  );
}

const styles = {
  main: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    margin: 0,
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    background: '#f4f6f8',
  },
  card: {
    width: '100%',
    maxWidth: '360px',
    padding: '32px',
    borderRadius: '12px',
    background: '#ffffff',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  },
  title: {
    margin: '0 0 24px',
    fontSize: '24px',
    textAlign: 'center',
    color: '#111827',
  },
  label: {
    display: 'block',
    marginBottom: '6px',
    fontSize: '14px',
    fontWeight: 500,
    color: '#374151',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    marginBottom: '16px',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    fontSize: '16px',
    boxSizing: 'border-box',
    outlineColor: '#2563eb',
  },
  button: {
    width: '100%',
    padding: '12px 16px',
    marginTop: '8px',
    border: 'none',
    borderRadius: '8px',
    background: '#2563eb',
    color: '#ffffff',
    fontSize: '16px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  result: {
    marginTop: '20px',
    textAlign: 'center',
    fontSize: '18px',
    color: '#059669',
  },
  error: {
    marginTop: '16px',
    textAlign: 'center',
    fontSize: '14px',
    color: '#dc2626',
  },
};

export default App;
